export interface IJitsiSettings {
  tokenString: string;
}
